export default "__VITE_ASSET__D3QwzY_c__"